export enum AnnualStatementPageFilter {
  Burning,
  ReadyToSend,
  NotReceived,
  Expected,
  Sent,
  PaymentDue,
  Overdue,
  Archived,
  All
}

export enum AnnualStatementStatus {
  ReadyToPrepare,
  ReadyToSend,
  NotReceived, 
  Expected,
  Sent,
  Signed,
  Finalized,
  Archived,
  Ignored
}

export enum SigningStatus {
  ReadyToSend,
  Created,
  Sent,
  Signed,
  MarkedAsSigned,
  MarkedAsSent,
  Rejected,
  SentViaEmail
}

export enum AnnualStep {
  Authorisation = 0,
  GenerateDocuments = 1,
  SignDocuments = 2
}

export enum SignGroup {
  Approver = 1,
  Signatories = 2,
  CarbonCopy = 3
}

export enum SendOption {
  Sign = 'SIGN',
  Email = 'Email',
  Paper = 'Paper',
  Sms = 'SMS'
}

export enum SignColumn {
  Name = 0,
  Email = 1,
  Phone = 2,
  Status = 3,
  Action = 4,
}

